import axios from "lib/axios";
import { callGet } from "./base";
import { compactHash } from "lib/utilities";

const UNREAD_URL = '/api/messaging/messages'

function allMessages({ page = null, per_page = 20 } = {}) {
  const params = new URLSearchParams(compactHash({ page, per_page, excluding_self: true }))

  return callGet(`${UNREAD_URL}?${params}`)
}

export default allMessages